import { Content, Breadcrumbs } from "@/components/features/newsroom";
import Footer from "../../components/common/layout/Footer";
import SEO from "@/components/common/seo/seo";

export default function Newsroom() {
    return (
        <div>
            <SEO
                title="Newsroom - SAN micron"
                description="Stay updated with the latest news, insights, and developments from SAN micron. Explore our newsroom for articles, press releases, and industry trends."
            />
            <Breadcrumbs />
            <Content />
            <Footer />
        </div>
    );
}